import "core-js/stable";
import Vue from "vue";
import App from "./App";
import "@/plugins/http.js";
import axios from "axios";
import router from "./router";
import CoreuiVue from "@coreui/vue";
import { iconsSet as icons } from "./assets/icons/icons.js";
import store from "./store";
import i18n from "@/lang";
import BootstrapVue from "bootstrap-vue";
import "bootstrap-vue/dist/bootstrap-vue.css";
import vSelect from "vue-select";
import DatePicker from "vue2-datepicker";
import "vue-select/dist/vue-select.css";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/ru";
import Vuesax from "vuesax";
import "vuesax/dist/vuesax.css";
import tinymce from "vue-tinymce-editor";
Vue.component("tinymce", tinymce);
Vue.config.performance = true;
Vue.use(CoreuiVue);
Vue.use(BootstrapVue);
Vue.prototype.$log = console.log.bind(console);
Vue.component("v-select", vSelect);
Vue.component("date-picker", DatePicker);
Vue.use(Vuesax);

axios.defaults.baseURL = "http://normaxtv-api.apptest.uz/";
if (window.location.href.indexOf("http://normaadmin.uzedu.uz") > -1) {
  axios.defaults.baseURL = "http://norma-api.uzedu.uz/";
}
if (window.location.href.indexOf("https://normaadmin.uzedu.uz") > -1) {
  axios.defaults.baseURL = "https://norma-api.uzedu.uz/";
}
// axios.defaults.baseURL = 'http://localhost:5000/'
new Vue({
  el: "#app",
  router,
  store,
  icons,
  i18n,
  template: "<App/>",
  components: {
    App,
  },
});
